<template>
  <v-app>
    <!-- Navigation drawer -->
    <v-navigation-drawer v-model="drawer" app fixed>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>1MODA Collect</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          link
          @click="menuItemClicked(item)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="loggedIn" @click="logout" link>
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Top Navigation Bar -->
    <v-app-bar fixed app color="white">
      <v-icon class="mr-5" @click="menuClicked">mdi-menu</v-icon>

      <v-text-field
        v-if="$store.state.searchBar"
        class="mt-5"
        v-model="search"
        placeholder="Search..."
        autofocus
      ></v-text-field>
      <v-btn
        icon
        color="primary"
        @click="search = ''"
        v-if="$store.state.searchBar"
        ><v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Body -->
    <v-content>
      <v-container fluid>
        <router-view :search="search"></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { authComputed } from "@/store/helpers.js";

export default {
  name: "App",

  components: {},

  data() {
    return {
      links: [
        {
          label: "Home",
          url: "/"
        },
        {
          label: "Expected",
          url: "/expected"
        }
      ],
      drawer: false,
      menuItems: [
        { title: "Home", icon: "mdi-home", route: "/" },
        {
          title: "Expected",
          icon: "mdi-application-import",
          route: "/expected"
        },
        { title: "Sellers", icon: "mdi-store", route: "/sellers" }
      ],
      search: ""
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    menuClicked() {
      this.drawer = !this.drawer;
    },
    menuItemClicked(item) {
      this.drawer = false;
      if (item.title == "Expected") {
        this.$store.commit("SHOW_SEARCHBAR", true);
      } else {
        this.$store.commit("SHOW_SEARCHBAR", false);
      }
      this.$router.push(item.route);
    }
  },
  computed: {
    ...authComputed
  }
};
</script>
